const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    height: "64px",
    width: "100%",
    padding: "0 16px",
    backgroundColor: "#1f1f1f",
    borderRadius: "8px",
    boxSizing: "border-box",
    marginTop: "16px",
    marginBottom: "16px",
    cursor: "pointer",
  },
  iconButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 0,
    marginRight: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  title: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    flex: 1,
  },
};

export default styles;